import { Form, Radio } from 'antd';
import React, { FC, useEffect } from 'react';
import { AssessmentAssigneeOption } from '../Helpers';

type Props = {
  disabled: boolean;
  value: AssessmentAssigneeOption;
  isSgreUser: boolean;
  onChange: (e: AssessmentAssigneeOption) => void;
};

const AssessmentAssignee: FC<Props> = ({ disabled, value, isSgreUser, onChange }) => {
  useEffect(() => {
    if (isSgreUser) {
      onChange(AssessmentAssigneeOption.SGRE);
    }
  }, [isSgreUser, onChange]);

  return (
    <Form.Item label='Assessment assignee'>
      <Radio.Group disabled={disabled} onChange={e => onChange(e.target.value)} value={value}>
        <Radio disabled={isSgreUser} value={AssessmentAssigneeOption.Own}>
          Own
        </Radio>
        <Radio value={AssessmentAssigneeOption.SGRE}>SGRE</Radio>
        {/* <Radio value={AssessmentAssigneeOption.Both}>Both</Radio> */}
      </Radio.Group>
    </Form.Item>
  );
};

export default AssessmentAssignee;
